import React from "react";
import { SUPPORT_EMAIL } from "./constants";
import "./FeedbackInvite.css";

const FEEDBACK_MAIL_SUBJECT = "BadgeFlow feedback";

export const getFeedbackMailtoHref = () =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(FEEDBACK_MAIL_SUBJECT)}`;

export const openCrispChat = () => {
  window.$crisp = window.$crisp || [];
  window.$crisp.push(["do", "chat:open"]);
};

const FeedbackInvite = ({
  onEmailClick,
  variant = "panel",
  emailLinkText,
  omitFooter = false,
}) => {
  const mailtoHref = getFeedbackMailtoHref();
  const linkLabel = emailLinkText ?? "Send feedback via email";
  const isPanelVariant = variant === "panel";

  return (
    <div className={`feedback-invite__body feedback-invite__body--${variant}`}>
      <p>
        BadgeFlow is still in beta — we are actively improving the app and adding
        new features.
      </p>
      <p>
        See a bug, need a feature, or have an idea? Send us a quick note via the chat — we read
        everything and use it to improve the app.
      </p>
      <p>
        Thank you!
      </p>
    </div>
  );
};

export default FeedbackInvite;
